import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { IonIcon } from '@ionic/angular';

import { DiscussionListItem } from '../../models/discussion.models';

import { DiscussionListItemParticipantComponent } from './discussion-list-item-participant.component';

@Component({
  selector: 'nty-discussion-list-item-participants',
  imports: [IonIcon, DiscussionListItemParticipantComponent],
  template: `
    <nty-discussion-list-item-participant [discussion]="discussion" mode="manager" />

    <ion-icon name="swap-horizontal" size="large" />

    <nty-discussion-list-item-participant [discussion]="discussion" mode="managee" />
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: [
    `
      @use 'terra';

      :host {
        display: flex;
        align-items: center;
        gap: 6px;
        margin-bottom: 12px;
      }

      ion-icon {
        width: 20px;
        color: terra.color(neutral-mid, 400);
      }
    `,
  ],
})
export class DiscussionListItemParticipantsComponent {
  @Input({ required: true }) discussion!: DiscussionListItem;
}
